import { useEffect, useRef, useState } from "react";
import "./input-upload.css";
import { Button } from "../button";
import { Icon } from "../icon";

interface UploadProps {
  entityId?: string;
  label: string;
  name?: string;
  value?: string | null;
  onChange?: (file: File | null) => void;
}

export default function InputUpload({
  entityId,
  label,
  name,
  value,
  onChange,
}: UploadProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [preview, setPreview] = useState<string | null>(
    !!value ? value : null
  );

  const handleFileChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;
    onChange?.(file);
    setPreview(URL.createObjectURL(file));
  };

  const removePhoto = () => {
    onChange?.(null);
    setPreview(null);

    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  useEffect(() => {
    setPreview(value ?? null);
  }, [value, entityId]);

  return (
    <div className="photo-upload">
      <p className="photo-upload-label">{label}</p>
    
      <input
        ref={inputRef}
        hidden
        type="file"
        accept="image/*"
        name={name}
        onChange={handleFileChange}
      />

      {!preview ? (
        <button
          type="button"
          className="photo-upload-placeholder"
          onClick={() => inputRef.current?.click()}
        >
          <Icon name="upload" size="small"/>
          Ajouter une photo
        </button>
      ) : (
        <div className="photo-upload-preview">
          <img src={preview} alt="preview" />

          <div className="photo-upload-actions">    
            <Button
                label="Supprimer"
                type="button"
                onClick={removePhoto}
                variant="secondary"
            />
            <Button
                label="Modifier"
                type="button"
                onClick={() => inputRef.current?.click()}
            />
          </div>
        </div>
      )}
    </div>
  );
}